module.exports = __webpack_public_path__ + "assets/fd14e0160a0a68c30e9db0e314fa397c.mp4";